import { versionInfo as version } from "../version"
import { SlashID, __INTERNAL_ONLY } from "../main/index"
import { BrowserUser as User } from "../main/user.browser"
import * as domainErrors from "../domain/errors"
import { runtimeSupportsBestPasskeyUX } from "../utils/passkeys"
import { CredentialsStorageV2 } from "../main/storage"
import { PUBLIC_READ_EVENTS, PUBLIC_WRITE_EVENTS, PublicReadEventsKeys, PublicWriteEventsKeys } from "../utils/events"

// this is required for the customers to be able to use the enum, not just evaluate types against it
import { PersonHandleType, WebAuthnAuthenticatorAttachment } from "../clients/slashid-api"
import {
    Factor,
    FactorMethod,
    ReachablePersonHandle,
    ReachablePersonHandleType,
    isReachablePersonHandleType,
} from "../domain/interfaces"
import { BaseUser, type UserToken } from "../main/user.base"
import { BaseAnalytics } from "../main/analytics/analytics.base"
import { AnalyticsOptions, AnalyticsTransport } from "../main/analytics/analytics.types"
import { SlashIDOptions } from "../domain/options"
import { createAnonymousUserToken } from "../main/user.utils"
import { AnonymousUser } from "../main/user.anonymous"
import { ChallengeProcessor as SSRChallengeProcessor } from "../domain/challenges.ssr"
import type {
    SlashIDError,
    APIResponseError,
    BadPasskeyScopeError,
    FlowCancelledError,
    HandlePatternNotAllowedError,
    InvalidActionError,
    InvalidAuthenticationMethodError,
    InvalidSlashIDConfigurationError,
    InvalidURLParamsError,
    NoPasswordSetError,
    NonReachableHandleTypeError,
    PasskeyPromptError,
    PersonExistsError,
    RateLimitError,
    SelfRegistrationNotAllowedError,
    SignInAwaitingApprovalError,
    SignUpAwaitingApprovalError,
    TimeoutError,
    HookFactorUnresolvedError,
    UnexpectedError,
    InvalidEmailAddressFormatError,
    InvalidPhoneNumberFormatError,
} from "../domain/errors"

const SSR = {
    User: BaseUser,
    Analytics: BaseAnalytics,
    createAnonymousUserToken,
    ChallengeProcessor: SSRChallengeProcessor,
}

// re-exporting does not work without creating a new object
const errors = {
    ...domainErrors,
}
// for naming consistency - namespaces are PascalCase
const Errors = {
    ...errors,
}

const Utils = {
    runtimeSupportsBestPasskeyUX,
    isReachablePersonHandleType,
    PUBLIC_READ_EVENTS,
    PUBLIC_WRITE_EVENTS,
}

// enums that are used in runtime are exported this way
export {
    SlashID,
    __INTERNAL_ONLY,
    SSR,
    User,
    AnonymousUser,
    createAnonymousUserToken,
    version,
    errors,
    Errors,
    WebAuthnAuthenticatorAttachment,
    PersonHandleType,
    Utils,
}
// everything exported as a type gets removed during runtime so we only use this for type-checking
export type {
    FactorMethod,
    Factor,
    CredentialsStorageV2,
    AnalyticsOptions,
    AnalyticsTransport,
    SlashIDOptions,
    // prevent name collisions for error types
    SlashIDError,
    APIResponseError,
    BadPasskeyScopeError,
    FlowCancelledError,
    HandlePatternNotAllowedError,
    InvalidActionError,
    InvalidAuthenticationMethodError,
    InvalidEmailAddressFormatError,
    InvalidPhoneNumberFormatError,
    InvalidSlashIDConfigurationError,
    InvalidURLParamsError,
    NoPasswordSetError,
    NonReachableHandleTypeError,
    PasskeyPromptError,
    PersonExistsError,
    PublicReadEventsKeys,
    PublicWriteEventsKeys,
    RateLimitError,
    SelfRegistrationNotAllowedError,
    SignInAwaitingApprovalError,
    SignUpAwaitingApprovalError,
    TimeoutError,
    HookFactorUnresolvedError,
    UnexpectedError,
    ReachablePersonHandle,
    ReachablePersonHandleType,
    UserToken,
}
